import Cgl from 'Cgl';
import SiteConfig from 'site-config';

export default {
    mounted() {
        this.$nextTick(() => {
            this.$root.qiankunProps.onGlobalStateChange(
                this.OnGlobalStateChange,
                true
            );
        });
    },
    methods: {
        OnGlobalStateChange(state, prev) {
            if (this.$root.qiankunProps?.detailUserForm?.Type === "DetailUserForm") {
                CmnMis.Frame.ShowUserForm(this.$root.qiankunProps.detailUserForm);
                return;
            }
            console.log(SiteConfig.SysGUID !== state.currentSysGUID, SiteConfig.SysGUID, state.currentSysGUID);
            if (SiteConfig.SysGUID !== state.currentSysGUID) {
                return;
            }

            let _viewStateData = { IsShowPreUserForm: '0' };
            if (
                state.currentUserFormID === this.$route.params.ufid &&
                Cgl.Url.GetParamFromUrl('ViewStateData') !== ''
            ) {
                _viewStateData = $.parseJSON(
                    decodeURIComponent(Cgl.Url.GetParamFromUrl('ViewStateData'))
                );
            }

            CmnMis.Frame.ShowUserForm(state.currentUserFormID, _viewStateData);
        }
    }
};
